import type { V10ProjectListItem } from "./v10-fixtures.js";
import type { V10QueueRiskLevel } from "./v10-queue-risk.js";

export type V10PipelineStageFilter = "all" | V10ProjectListItem["group"];
export type V10PipelineDueFilter = "all" | "on_track" | "waiting_client" | "blocked";
export type V10PipelineRiskFilter = "all" | V10QueueRiskLevel;
export type V10PipelineClientActionFilter = "all" | "outstanding" | "none";

export type V10PipelineFilterState = {
  readonly stage: V10PipelineStageFilter;
  readonly due: V10PipelineDueFilter;
  readonly risk: V10PipelineRiskFilter;
  readonly clientAction: V10PipelineClientActionFilter;
};

export const V10_PIPELINE_FILTER_DEFAULTS: V10PipelineFilterState = {
  stage: "all",
  due: "all",
  risk: "all",
  clientAction: "all",
};

export type V10PipelineRow = V10ProjectListItem;

export function deriveV10PipelineDueLabel(group: V10ProjectListItem["group"]): string {
  switch (group) {
    case "waiting-client":
      return "Waiting on client";
    case "blocked":
      return "Blocked / overdue";
    case "handoff-ready":
      return "Handoff due";
    case "draft":
      return "Setup in progress";
    default:
      return "On track";
  }
}

export function deriveV10PipelineDueFilter(group: V10ProjectListItem["group"]): V10PipelineDueFilter {
  if (group === "waiting-client") return "waiting_client";
  if (group === "blocked") return "blocked";
  return "on_track";
}

export function applyV10PipelineFilters(
  rows: readonly V10PipelineRow[],
  filters: V10PipelineFilterState,
): readonly V10PipelineRow[] {
  return rows.filter((row) => {
    if (filters.stage !== "all" && row.group !== filters.stage) return false;
    const due = deriveV10PipelineDueFilter(row.group);
    if (filters.due !== "all" && due !== filters.due) return false;
    if (filters.risk !== "all" && row.riskLevel !== filters.risk) return false;
    if (filters.clientAction === "outstanding" && !row.outstandingClientAction) return false;
    if (filters.clientAction === "none" && row.outstandingClientAction) return false;
    return true;
  });
}
